import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator/index';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { FHETitle } from 'data/components';
import { SvgHome } from 'data/common/iconsvg/index';

class AddProductTitle extends PureComponent {
    static propTypes = {
        boxMac: PropTypes.string.isRequired,
        homeLabel: PropTypes.string.isRequired,
        homeId: PropTypes.string.isRequired,
        subTitle: PropTypes.bool.isRequired
    };

    render() {
        const { boxMac, homeId, homeLabel, subTitle } = this.props;
        return (
            <FHETitle
                title={Translator.translate('generic.products.addProduct.title', homeLabel)}
                Icon={SvgHome}
                subTitle={subTitle ? `Home ID: ${homeId} / FHE-Center Mac: ${boxMac.match(/.{1,2}/g).join(':')}` : null}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const boxMac = props.boxMac ? props.boxMac : '';
    let homeId = '';
    let homeLabel = '';
    if (boxMac !== '') {
        homeId = state.environments.fhe.data.Boxes.getIn(['list', props.boxMac], new Map())
            .getIn(['homeId'], '')
            .toString();
        homeLabel = homeId !== 0 && state.environments.fhe.data.Homes.getIn(['list', homeId], new Map()).getIn(['label'], null);
    }
    return {
        boxMac,
        homeId,
        homeLabel
    };
}

const styles = () => ({});

export default withRouter(connect(mapStateToProps)(withStyles(styles, { withTheme: true })(AddProductTitle)));



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Products/components/provisionning/AddProductTitle.js